<template>
  <v-app class="pa-3">
    <v-app-bar
      class="px-5"
      app
      flat
    >
      <!--      <a-->
      <!--        href="http://abriron.com"-->
      <!--        target="_blank"-->
      <!--      >-->
      <!--        <v-img-->
      <!--          width="120"-->
      <!--          src="https://abriron.com/wp-content/uploads/2020/12/ironlogo.png"-->
      <!--        />-->
      <!--      </a>-->
      <v-spacer />
      <language v-model="lang" />
    </v-app-bar>
    <v-main>
      <v-container>
        <v-form ref="form">
          <v-card
            class="mx-auto justify-center mb-1 mt-3"
            max-width="500"
            :elevation="(isMobile ? 0 : 10)"
            :flat="isMobile"
          >
            <v-row
              v-if="status"
              :class="{'mx-0' : !isMobile}"
            >
              <v-card-title
                class="justify-center mx-auto  my-4"
                grey
                darken-3
                style="word-break: normal !important;text-align: center;"
              >
                {{ $t('AcademyInterviewRegistered') }}
              </v-card-title>
            </v-row>
            <v-row
              v-if="!status"
              :class="{'mx-0' : !isMobile}"
            >
              <v-card-title
                class="justify-center mx-auto  my-4"
                grey
                darken-3
              >
                {{ $t('reserveInterview') }}
              </v-card-title>
              <v-col
                class="py-0 mb-6"
                cols="12"
              >
                <v-text-field
                  v-model="firstname"
                  :label="$t('name')"
                  :rules="[v => !!v || $t('is-required')]"
                  dense
                  outlined
                  clearable
                />
              </v-col>
              <v-col
                class="py-0 mb-6"
                cols="12"
              >
                <v-text-field
                  v-model="lastname"
                  :label="$t('last-name')"
                  :rules="[v => !!v || $t('is-required')]"
                  dense
                  outlined
                  clearable
                />
              </v-col>
              <v-col
                cols="12"
                class="py-0 mb-6"
              >
                <v-text-field
                  v-model="nationalCode"
                  :label="$t('national-code')"
                  height="20"
                  dense
                  :rules="[v => !!v || $t('is-required')]"
                  outlined
                  class="mb-1 dense"
                  clearable
                />
              </v-col>
              <v-col
                cols="12"
                class="py-0 mb-6"
              >
                <autocomplete
                  v-model="category"
                  title="academyCategory"
                  type="academyCategoryInterview"
                  :url="true"
                  :url-key="key"
                />
              </v-col>
              <v-col
                v-if="items"
                cols="12"
              >
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>
                          {{ $t('date') }}
                        </th>
                        <th>
                          {{ $t('time') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, i) in items"
                        :key="i"
                      >
                        <td>{{ item.date }}</td>
                        <td>
                          <v-chip-group
                            v-model="timeReserve"
                            column
                            active-class="primary--text"
                          >
                            <v-chip
                              v-for="(time, j) in item.items"
                              :key="j"
                              filter
                              outlined
                              :value="time"
                            >
                              {{ time.start_time }}
                            </v-chip>
                          </v-chip-group>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col
                v-if="items"
                class="px-3  xs mt-2"
                cols="12"
              >
                <v-btn
                  v-shortkey="['enter']"
                  :loading="loading"
                  block
                  :disabled="(!timeReserve ? true : false)"
                  color="deep-purple accent-2 mr-0"
                  @shortkey="submit"
                  @click="submit"
                >
                  {{ $t('continue') }}
                  <v-icon
                    right
                    dark
                  >
                    mdi-keyboard_return
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-container>
    </v-main>
    <v-footer
      class="py-2"
      style="font-size: 12px;position: fixed;background-color: #fff"
      app
    >
      <v-col
        class="text-center py-1"
        cols="12"
      >
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-app>
</template>

<script>
import General from '../../../../Mixins/general'
import Snakbar from '../../components/general/snakbar/snakbar'
import autocomplete from '../../components/general/patial/autocomplete'
import Language from '../../components/core/LanguageBar'
export default {
  components: {
    Language,
    autocomplete,
    Snakbar
  },
  mixins: [General],
  props: ['emailProp', 'planProp', 'phoneProp', 'phonePrefixProp', 'keyProp'],
  data () {
    return {
      status: null,
      currency: null,
      phonePrefix: null,
      timeReserve: null,
      mobile: null,
      category: null,
      nationalCode: null,
      dateFormat: 'fa,en',
      dateFormatLang: 'YYYY/MM/DD',
      yearName: null,
      from: null,
      to: null,
      show: null,
      code: null,
      lang: null,
      firstname: null,
      lastname: null,
      username: null,
      key: null,
      items: [],
      has_error: false,
      text_error: null,
      loading: false
    }
  },
  watch: {
    dateFormat () {
      this.from = null
      this.to = null
      if (this.dateFormat === 'fa,en') {
        this.dateFormatLang = 'jYYYY/jMM/jDD'
      }
      if (this.dateFormat === 'en,fa') {
        this.dateFormatLang = 'YYYY/MM/DD'
      }
    },
    category (val) {
      if (val) {
        this.getSession()
      } else {
        this.items = []
      }
    }
  },
  beforeMount () {
    if (this.keyProp) {
      this.key = this.keyProp
    }
    if (this.$route.query && this.$route.query.ak) {
      this.key = this.$route.query.ak
    }
    if (!this.phoneProp) {
      // this.goTo('register')
    }
    this.phonePrefix = this.phonePrefixProp
    this.mobile = this.phoneProp
    this.plan = this.planProp
    if (this.dateFormat === 'fa,en') {
      this.dateFormatLang = 'jYYYY/jMM/jDD'
    }
    if (this.dateFormat === 'en,fa') {
      this.dateFormatLang = 'YYYY/MM/DD'
    }
  },
  mounted () {
    if (localStorage.getItem('lang')) {
      this.$refs.refLang.changeLanguage(JSON.parse(localStorage.getItem('lang')))
    }
  },
  methods: {
    phoneCheck (formattedNumber, { number, valid, country }) {
      this.phonePrefix = country.dialCode
      var phoneNumber = number.input.replace(/\s/g, '')
      phoneNumber = phoneNumber.replaceAll('-', '')
      phoneNumber = phoneNumber.replace('+', '')
      this.phone = phoneNumber
    },
    submit () {
      var app = this
      app.loading = true
      if (this.key) {
        app.$axios.defaults.headers.common.abr_key = this.key
      }
      app.$axios.post(this.$apipoint + 'academy/interview/student', app.$data)
        .then(res => {
          res = res.data
          app.status = true
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (this.loading = false))
    },
    editEmail () {
      this.goTo('register')
    },
    getSession () {
      this.loading = true
      var app = this
      if (this.key) {
        app.$axios.defaults.headers.common.abr_key = this.key
      }
      var url = app.$apipoint + 'getcurrency'
      app.$axios.get(url, {
        params: {
          select: 'academyCategorySession',
          category: app.category,
          search: null
        }
      }).then(res => {
        res = res.data
        this.items = res
      })
        .catch(err => {
          app.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    }
  }

}
</script>

<style scoped>

</style>
